import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface Assignment {
  id: string;
  tenantId: string;
  feePolicyId: string;
  endCustomerBusinessId: string;
  effectiveFrom: string;
  effectiveUntil: string | null;
  isActive: boolean;
  TenantFeePolicy?: {
    id: string;
    name: string | null;
    scope: "DEFAULT" | "NAMED";
    status: "DRAFT" | "SCHEDULED" | "ACTIVE" | "SUSPENDED" | "ARCHIVED";
    calculationMethod: "PERCENTAGE" | "FLAT" | "TIERED";
  };
}

export interface ListParams {
  feePolicyId?: string;
  customerBusinessId?: string;
  includeInactive?: boolean;
  page?: number;
  limit?: number;
}

export const list = (params?: ListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/fee-policy-assignments", params as any);

export const assign = (body: {
  customerBusinessId: string;
  feePolicyId: string;
  effectiveFrom?: string;
}) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post("/bil/my/fee-policy-assignments", body as any);

export const assignBulk = (body: {
  customerBusinessIds: string[];
  feePolicyId: string;
  effectiveFrom?: string;
}) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post("/bil/my/fee-policy-assignments/bulk", body as any);

export const unassign = (id: string) =>
  httpRequest.del(`/bil/my/fee-policy-assignments/${id}`);

// --- Fee-policy customer roster (spec §3.3 Customers tab) -----------------
export interface EffectivePolicy {
  id: string | null;
  name: string | null;
  scope: "DEFAULT" | "NAMED";
  calculationMethod: "PERCENTAGE" | "FLAT" | "TIERED" | null;
  feeRate: string | null;
  flatFeeAmount: string | null;
}

export interface FeePolicyCustomer {
  businessId: string;
  name: string | null;
  type: string;
  // Taxpayer registration number (ТТД), or null when the business has none.
  regNumber: string | null;
  // Active NAMED assignment id (revert handle), or null when on DEFAULT.
  assignmentId: string | null;
  effectivePolicy: EffectivePolicy | null;
}

export interface ListCustomersParams {
  search?: string;
  // Named policy id, or "DEFAULT" sentinel for unassigned customers.
  feePolicyId?: string;
  // Business type filter — BUYER (Худалдан авагч) or SUPPLIER (Нийлүүлэгч).
  type?: "BUYER" | "SUPPLIER";
  page?: number;
  limit?: number;
}

export interface ListCustomersResult {
  rows: FeePolicyCustomer[];
  total: number;
  page: number;
  limit: number;
  // Roster members with no active NAMED assignment (i.e. on the DEFAULT policy).
  defaultCount: number;
  // Active NAMED assignment counts, keyed by feePolicyId.
  perPolicy: Record<string, number>;
}

export const listCustomers = (params?: ListCustomersParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/fee-policy-customers", params as any) as Promise<ListCustomersResult>;
